import { ReactComponent as Invisible } from 'src/_shared/assets/svg/it-password-invisible.svg';
import { ReactComponent as Visible } from 'src/_shared/assets/svg/it-password-visible.svg';
import { ReactComponent as Search } from 'src/_shared/assets/svg/it-search.svg';
import React, { InputHTMLAttributes, useState } from 'react';
import './styles/textfield.components.style.scss';

export interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
    isSearchable?: boolean;
    fullWidth?: boolean;
    error?: { [x: string]: any };
    errorMessage?: string;
}

const TextField: React.FC<TextFieldProps> = React.forwardRef(({ isSearchable = false, type = 'text', error, name, errorMessage, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);
    const { className } = props;
    const hasIcon = (isSearchable && type !== 'password') || type === 'password';
    return (
<>
  <div className="d-flex flex-row align-items-center input-container position-relative">
    <input
      {...props}
      ref={ref as React.MutableRefObject<HTMLInputElement>}
      name={name}
      type={showPassword ? 'text' : type}
      className={`${className} form-control ${hasIcon ? 'pe-5' : ''}`} // add right padding to make room for icons
      aria-invalid={!!error}
    />

    {/* Search icon */}
    {isSearchable && type !== 'password' && (
      <span className="text-field-icon">
        <Search className="text-field-svg-container" fill="#009138" />
      </span>
    )}

    {/* Password toggle */}
    {type === 'password' && (
      <button
        type="button"
        className="password-toggle-btn"
        onClick={() => setShowPassword(prev => !prev)}
        aria-label={showPassword ? 'Nascondi password' : 'Mostra password'}
      >
        {showPassword ? (
          <Invisible className="password-icon-visible icon icon-sm" />
        ) : (
          <Visible className="password-icon-invisible icon icon-sm" />
        )}
      </button>
    )}
  </div>

  {error && <small className="form-text error-message text-danger">{errorMessage}</small>}
</>

    );
});

export default TextField;
